<template>
    <div class="page-user-edit">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">後臺管理</div>
            <div class="breadcrumb-item">APP通知管理 修改</div>
        </div>

        <div class="pg-block">
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>

            <div class="pg-form-wrap">
                <Row>
                    <Col span="18" push="5">
                        <Form :label-width="200">
                            <Row :gutter="15">
                                <Col span="18">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>通知類型</span>
                                        </div>

                                        <Select size="small" style="width: 120px;" placeholder="通知類型" v-model="form.activity">
                                            <Option :value="1">活動通知</Option>
                                            <Option :value="2">系統通知</Option>
                                        </Select>
                                    </FormItem>

                                    <FormItem v-show="form.activity == '1'">
                                        <div slot="label" class="form-label">
                                            <span>圖片預覽</span>
                                        </div>
                                        <div class="form-upload-img">
                                            <!-- <div class="img-preview" v-if="uploadFile.base64"> -->
                                            <!--    <img style="width: 200px;" :src="form.image" alt="">-->
                                            <!-- </div> -->
                                            <el-image
                                                style="width: 200px;"
                                                :z-index="99999"
                                                :src="form.image"
                                                :preview-src-list="[form.image]">
                                            </el-image>
                                            <Upload :before-upload="handleBeforeUpload"
                                                    accept="image/png, image/jpg, image/jpeg"
                                                    action="">
                                                <div class="upload-btn">選擇圖片</div>
                                            </Upload>
                                            <div class="upload-tip">尺寸：750*170px 格式：PNG、JPG</div>
                                            
                                        </div>
                                    </FormItem>

                                    <FormItem v-show="form.activity == '1'">
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>圖片上傳</span>
                                        </div>
                                        <Input v-model="form.image" style="width:100%" clearable/>
                                    </FormItem>
                                    
                                     <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>通知標題</span>
                                        </div>

                                        <Input v-model="form.title" style="width:100%" clearable/>
                                    </FormItem>

                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>通知内容</span>
                                        </div>

                                        <!--<Input type="textarea" :autosize="{minRows: 5,maxRows: 10}" placeholder="Enter something..." v-model="form.content" clearable/>-->
                                        <textarea v-model="form.content" hidden readonly></textarea>
                                        <div id="demo1"></div>
                                    </FormItem>
                                    
                                    <Row :gutter="15">
                                        <Col span="15">
                                            <FormItem>
                                                <div slot="label" class="form-label">
                                                    <em class="red">* </em>
                                                    <span>通知时间</span>
                                                </div>
                                                <Input v-model="form.noticeTime" style="width:100%" placeholder="年-月-日" clearable/>
                                               
                                            </FormItem>
                                        </Col>
                                    </Row>
                                    
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <!--<em class="red">* </em>-->
                                            <span>跳轉鏈接</span>
                                        </div>
                                        <Input v-model="form.link" style="width:100%" clearable/>
                                    </FormItem>
                                    
                                    <FormItem>
                                        <div>
                                            
                                            <el-tree
                                                ref="el_tree"
                                                :data="treeData"
                                                show-checkbox
                                                node-key="ReceivingID"
                                                :default-expanded-keys="[]"
                                                :default-checked-keys="form.stores"
                                                :props="defaultProps"
                                            />
                                        </div>
                                    </FormItem>

                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>開始時間</span>
                                        </div>
                                        <DatePicker class="no-suffix" type="datetime" size="small" :clearable="false"
                                            placeholder="開始日期" v-model="form.notiTimeStrat" value-format="yyyy-MM-dd hh:mm:ss" :editable="false" style='width: 100%;'></DatePicker>
                                    </FormItem>

                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>結束時間</span>
                                        </div>

                                        <DatePicker class="no-suffix" type="datetime" size="small" :clearable="false"
                                            placeholder="開始日期" v-model="form.notiTimeEnd" value-format="yyyy-MM-dd hh:mm:ss" :editable="false" style='width: 100%;'></DatePicker>
                                    </FormItem>

                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>彈窗次數</span>
                                        </div>

                                        <RadioGroup v-model="form.type">
                                            <Radio :label="1">
                                                <span>單次</span>
                                            </Radio>
                                            <Radio :label="2">
                                                <span>無限次數</span>
                                            </Radio>
                                        </RadioGroup>
                                    </FormItem>

                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>開啓</span>
                                        </div>
                                        <RadioGroup v-model="form.status">
                                            <Radio :label="1">
                                                <span>是</span>
                                            </Radio>
                                            <Radio :label="0">
                                                <span>否</span>
                                            </Radio>
                                        </RadioGroup>
                                    </FormItem>

                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>排序</span>
                                        </div>
                                        <Input v-model="form.weights" max="100" min="1" placeholder="1-100" clearable/>
                                    </FormItem>

                                </Col>
                            </Row>
                            <FormItem>
                                <div class="pg-btn-wrap">
                                    <div class="pg-btn style2" @click="handleCheckForm">修改</div>
                                    <div class="pg-btn" @click="handleBack">返回</div>
                                </div>
                            </FormItem>
                        </Form>
                    </Col>
                </Row>
            </div>
        </div>
    </div>
</template>

<script>
    import wangEditor from "wangeditor";

    export default {
        data()
        {
            return {
                uploadFile: {
                   file: '',
                   base64: '',
                },
                pageParam: {},
                detail: {},
                isSubmiting: false,
                form: {
                    activity: '',
                    title: '',
                    link: '',
                    image: '',
                    content: '',
                    weights: '',
                    sort: '',
                    type: '',
                    status: '',
                    notiTimeStrat: '',
                    notiTimeEnd: '',
                    noticeTime: '',
                    stores: []
                },
                editor: '',
                defaultProps: {
                    children: 'children',
                    label: 'ReceivingName',
                },
                treeData: [
                    {
                        ReceivingID: 1,
                        ReceivingName: '门店',
                        disabled: 1,
                        children: [],
                    },
                    {
                        ReceivingID: 2,
                        ReceivingName: '智能柜',
                        disabled: 2,
                        children: [],
                    },
                ]
            };
        },
        async mounted() {
            this.pageParam = this.$route.query;
            if(this.pageParam.id == undefined) {
                this.pageParam.id = 0;
            }
            
            const editor = new wangEditor(`#demo1`)
            editor.config.placeholder = '內容'
            editor.config.focus = true
            editor.config.onchange = (newHtml) => {
                this.form.content = newHtml
            }
            // https://jyb-admin-backend.aoyunltd.com/api/v1/jyb/commodity/order/fileupdate
            // http://jyb-admin-backend-test.aoyunltd.cn/api/v1/jyb/commodity/order/fileupdate
            editor.config.uploadImgServer = 'https://jyb-admin-backend.aoyunltd.com/api/v1/jyb/commodity/order/fileupdate';
            editor.config.uploadFileName = 'file'; //后端接受上传文件的参数名
            editor.config.uploadImgMaxSize = 10 * 1024 * 1024; // 将图片大小限制为 10M
            editor.config.uploadImgMaxLength = 1; // 限制一次最多上传 1 张图片
            editor.config.uploadImgHooks = {
                fail: (xhr, editor, result) => {
                    // 插入图片失败回调
                    console.log(result);
                },
                success: (xhr, editor, result) => {
                    // 图片上传成功回调
                    console.log(result);
                },
                timeout: (xhr, editor) => {
                    // 网络超时的回调
                    console.log('網絡超時');
                },
                error: (xhr, editor) => {
                    // 图片上传错误的回调
                    console.log('上傳錯誤');
                },
                //回显
                customInsert: (insertImg, result, editor) => {
                    let app_url = result.data.app_url;
                    let url = result.data.url;
                    let insert_img = app_url + url;
                    console.log(insert_img)
                    insertImg(insert_img);
                },
            };
    
            editor.create()
            this.editor = editor
            // this.editor.txt.html(this.form.content)
            await this.getPickAddress();
            this.getDetail();
        },
        methods: {
            //門店 智能柜
            async getPickAddress() {
                await this.$Rq.requestAuth({
                    url: this.$Api.pickAddress,
                    method: 'get',
                    data: {
                        company_id: 0,
                        type: ''
                    }
                }).then((res) => {
                    if (res.code == 0) {
                        this.treeData[0].children = res.data.data.filter(item => item.Type == 1).map(ite => {
                            ite.disabled = ite.ReceivingID
                            return ite
                        }).filter(it=>it.company_id != 15)
                        this.treeData[1].children = res.data.data.filter(item => item.Type == 2).map(ite => {
                            ite.disabled = ite.ReceivingID
                            return ite
                        }).filter(it=>it.company_id != 15)
                    }
                });
            },
            handleBeforeUpload(file)  //上传
            {
               this.uploadFile.file = file;
               this.hanldeImgToBase64();
               return false;
            },
            hanldeImgToBase64() {
               let file = this.uploadFile.file;
               let reader = new FileReader();
               reader.readAsDataURL(file);
               reader.onload = () => {
                  let _base64 = reader.result;
                  this.uploadFile.base64 = _base64;
               };
               this.handleUploadImg();
            },
            handleUploadImg() {
                this.isSubmiting = true;
                let formData = new FormData();
                formData.append('file', this.uploadFile.file);
                this.$Rq.requestAuth({
                    url: this.$Api.uploadImg,
                    method: 'post',
                    data: formData,
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    }
                }).then((res) => {
                    this.isSubmiting = false;
                    if (res.code == 0) {
                        this.form.image = res.data.app_url + res.data.url;
                    } else {
                        this.$Utils.showTipInfo(res.msg);
                    }
                }).catch((err) => {
                    this.isSubmiting = false;
                });
            },

            formatDate(datetime)
            {
                if (!datetime) return '';
                let dateTime = new Date(datetime);
                let year = dateTime.getFullYear();
                let month = dateTime.getMonth() + 1;
                let date = dateTime.getDate();
                let hour = dateTime.getHours();
                let minute = dateTime.getMinutes();
                let second = dateTime.getSeconds();
                let milliseconds = dateTime.getMilliseconds();
                return `${this.formatNum(year)}-${this.formatNum(month)}-${this.formatNum(date)} ${this.formatNum(hour)}:${this.formatNum(second)}:${this.formatNum(milliseconds)}`;
            },
            formatNum(num)
            {
                return num < 10 ? '0' + num : num;
            },
            handleBack()
            {
                this.$router.go(-1);
            },
            getDetail()
            {
                this.$Rq.requestAuth({
                    url: this.$Api.appNotificationManageList,
                    method: 'get',
                    data:{
                        id: this.pageParam.id
                    }
                }).then((res) =>
                {
                    if (res.code == 0)
                    {
                        let resData = res.data[0];
                        this.form = {
                            id: resData.id,
                            title: resData.title,
                            type: resData.type,
                            status: resData.status,
                            link: resData.link,
                            image: resData.image,
                            content: resData.content,
                            weights: resData.weights,
                            admin_id: resData.admin_id,
                            notiTimeStrat: resData.notiTimeStrat,
                            notiTimeEnd: resData.notiTimeEnd,
                            noticeTime: resData.datetext,
                            activity: resData.activity,
                            stores: resData.stores && JSON.parse(resData.stores)
                        };
                        this.editor.txt.html(resData.content);
                    }
                });
            },

            handleCheckForm()
            {
                let form = this.form;
                
               if(form.activity == 1 && !form.image){
                    this.$Utils.showTipInfo('請輸入圖片上傳');
                    return;
                }
                if (form.title === '') {
                    this.$Utils.showTipInfo('請输入通知标题');
                    return;
                }
                if (form.content === '') {
                   this.$Utils.showTipInfo('請選擇通知內容');
                   return;
                }
                if (form.weights === '') {
                   this.$Utils.showTipInfo('請輸入排序');
                   return;
                }
                if (form.activity === '') {
                   this.$Utils.showTipInfo('請輸入類型');
                   return;
                }
                if (form.type === '') {
                    this.$Utils.showTipInfo('請選擇彈框次數');
                    return;
                }
                if (form.status === '') {
                   this.$Utils.showTipInfo('請輸入狀態');
                   return;
                }
                if (form.notiTimeStrat === '') {
                   this.$Utils.showTipInfo('請輸入通知開始時間');
                   return;
                }
                if (form.notiTimeEnd === '') {
                   this.$Utils.showTipInfo('請輸入通知結束時間');
                   return;
                }
                if (form.stores?.length === 0) {
                    this.$Utils.showTipInfo('請選擇門店、櫃點');
                    return;
                }
                this.handleSubmit();
            },

            handleSubmit()
            {
                let form = this.form;
                this.isSubmiting = true;

                if(form.activity == 2) { // 系統通知
                    this.$Rq.requestAuth({
                        url: this.$Api.appNotificationManageStatusEdit + '/' + this.pageParam.id,
                        method: 'post',
                        data: {
                            activity: form.activity,
                            status: form.status,
                            content: form.content,
                            image: "",
                            link: form.link,
                            notiTimeEnd: this.formatDate(form.notiTimeEnd),
                            notiTimeStrat: this.formatDate(form.notiTimeStrat),
                            title: form.title,
                            type: form.type,
                            weights: form.weights,
                            datetext: form.noticeTime,
                        }
                    }).then((res) =>
                    {
                        this.isSubmiting = false;

                        if (res.code == 0)
                        {
                            this.$Utils.showSuccess(res.msg);
                            this.getDetail();
                        } else
                        {
                            this.$Utils.showTipInfo(res.msg);
                        }
                    }).catch((err) =>
                    {
                        this.isSubmiting = false;
                    });
                } else { // h活動通知
                    this.$Rq.requestAuth({
                        url: this.$Api.appNotificationManageStatusEdit + '/' + this.pageParam.id,
                        method: 'post',
                        data: {
                            activity: form.activity,
                            status: form.status,
                            content: form.content,
                            image: form.image,
                            link: form.link,
                            notiTimeEnd: this.formatDate(form.notiTimeEnd),
                            notiTimeStrat: this.formatDate(form.notiTimeStrat),
                            title: form.title,
                            type: form.type,
                            weights: form.weights,
                            datetext: form.noticeTime,
                        }
                    }).then((res) =>
                    {
                        this.isSubmiting = false;

                        if (res.code == 0)
                        {
                            this.$Utils.showSuccess(res.msg);
                            this.getDetail();
                        } else
                        {
                            this.$Utils.showTipInfo(res.msg);
                        }
                    }).catch((err) =>
                    {
                        this.isSubmiting = false;
                    });
                }
            }
        }
    };
</script>
<style>
.el-tree-node>.el-tree-node__children {
    max-height: 500px;
    overflow-y: auto;
}
</style>
<style lang="scss" scoped>
    @import "appNotificationManageEdit.scss";
</style>
